export const routes = (prefix=`reports`, pre=`patients`) => [
    {
        name: `${prefix}.${pre}.all-patients.index`,
        path: `/${prefix}/${pre}/all-patients`,
        component: () => import('./Index.vue'),
        meta: {
            requiresAuth: true,
            permissions: {
                PageName: `${prefix}.${pre}.all-patients.index`,
                PageDescription: "Patient Reports: All Patients report",
            },
        },
    },
    {
        name: `${prefix}.${pre}.print.all-patients.index`,
        path: `/${prefix}/${pre}/all-patients/print`,
        component: () => import('./prints/All.vue'),
        meta: {
            requiresAuth: true,
            permissions: {
                PageName: `${prefix}.${pre}.print.all-patients.index`,
                PageDescription: "Patient Reports: All Patients report",
            },
            print: true,
        },
    },
];